import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DocumentDialogComponent } from '../document-dialog/document-dialog.component'; // Adjust path as needed
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-doc-project',
  templateUrl: './add-doc-project.component.html',
  styleUrl: './add-doc-project.component.css'
})
export class AddDocProjectComponent implements OnInit{
    displayedColumns: string[] = ['srNo',
    'documentName', 'fileName',
  ];


  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  projectId: any;
  imageBaseUrl = environment.imageBaseUrl;
  constructor(private apiService: ApiService,
      private toastrMsgService: ToastrMsgService,
      private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog) {

  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
    ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];

    });
    if (this.projectId) {
      this.getProjectDetails();
    }
  }
   applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getProjectDetails() {
    const params = { projectId: this.projectId };
    console.log(params)
    this.apiService.getProject(params).subscribe({
      next: (res: any) => {
        const data = res.find((project: any) => project.project_id == this.projectId);
        this.dataSource.data = data?.documents;
        console.log(data?.documents)

      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
  }
  deleteProject(a:any){

  }
  // Open the dialog
  openAddDocumentDialog(): void {
    const dialogRef = this.dialog.open(DocumentDialogComponent, {
      width: '500px',
      disableClose: true,
      data: null // Can pass data for edit
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
        const formData = new FormData();
         formData.append('doc_name', result.doc_name);
         formData.append('projectFile', result.file);
         this.apiService.updateProjectDoc(this.projectId,formData).subscribe({
        next: (res) => {
          console.log(res);
          this.getProjectDetails();
          this.toastrMsgService.success("Document saved successfully");
        },
        error: (err) => {
          console.error(err);
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => console.log("Observable complete"),
      });
      }
    });
  }
}
